import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconWeight = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M17.5358 10.557L19.3881 16.4578C19.6172 17.1876 19.492 17.9287 19.0352 18.5449C18.5789 19.1608 17.9031 19.5 17.1327 19.5H6.86686C6.09666 19.5 5.42113 19.161 4.96455 18.5449C4.50797 17.9289 4.38283 17.1878 4.61187 16.4578L6.46416 10.557C6.72325 9.7317 7.37925 9.14273 8.20977 8.96565V7.37752C8.20977 6.59762 8.50321 5.89401 9.05874 5.34276C9.61385 4.7915 10.3229 4.5 11.1085 4.5H12.8911C14.4894 4.5 15.7898 5.79088 15.7898 7.37752V8.96565C16.6205 9.14251 17.2768 9.73148 17.5358 10.557ZM11.1087 6.63065C10.8902 6.63065 10.7312 6.69607 10.5768 6.84928C10.4223 7.0027 10.3566 7.1606 10.3568 7.3773V8.74148L11.1218 8.66797C11.139 8.66626 11.1562 8.66541 11.1734 8.66541H12.8271C12.8443 8.66541 12.8616 8.66626 12.8786 8.66797L13.6434 8.74148V7.3773C13.6434 6.96562 13.306 6.63065 12.8913 6.63065H11.1087Z" fill="currentColor" />
  </SvgIcon>
);

export default IconWeight;
